import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_FarsForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_FarsForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>STATE OF FLORIDA<br />ALCOHOL, DRUG ABUSE & MENTAL HEALTH</h3></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. *CONTRACTOR ID: 59-3128476</span>
                            Federal Employer ID# of agency directly contracted with SAMH. If your agency is subcontracted, enter the ID# of the contractor/ASO here.<br />
                            <input type='text' id='txtContractorId' name='txtContractorId' className='add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. *DCF EVALUATION(PURPOSE):</span>
                            1- Admission/Initiation into episode of care<br />
                            2- Six(6) month interval after admission<br />
                            3- Discharge from agency<br />
                            4- Administrative Discharge<br />
                            5- None of the Above (Program Evaluation Only) <br />
                            <input type='text' id='txtDcfEvaluation' name='txtDcfEvaluation' className='add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. *EVALUATION DATE:</span>
                            <input type='date' id='txtEvaluationDate' name='txtEvaluationDate' className='add-only w-200 custom-add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>5.</span>
                            Federal Employer ID# of the provider agency actually completing the FARS. Subcontracted agencies
                            Tax ID# goes here. Contractor agencies reenter the Contractor ID.<br />
                            <input type='text' id='txtProviderId' name='txtProviderId' className='add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>6.  Program Evaluation Purpose </span>
                            <span className='small'>(Optional):</span>

                            1- Admission to program<br />
                            2- Six months after admission to program<br />
                            3- Annually after admission to program or service<br />
                            4- Planned discharge from/transfer to, program or service within agency<br />
                            5- Administrative discharge<br />
                            6- None of the above<br />
                            <input type='text' id='txtProgramEvaluation' name='txtProgramEvaluation' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>7. M-GAF SCORE:</span>
                            <input type='text' id='txtScore' name='txtScore' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. *RATER EDUCATION / SPECIALTY:</span>
                            <input type='text' id='txtSpeciality' name='txtSpeciality' className='add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>9. *RATER FMHI CERTICATION# :</span>
                            <input type='text' id='txtCertification' name='txtCertification' className='add-only' required />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>10. *SUBSTANCE ABUSE HISTORY: </span>
                            Yes (1) or No (0) <br />
                            <input type='text' id='txtSubstanceAbuse' name='txtSubstanceAbuse' className='add-only' required />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>Respond to questions 11 through 28 with the appropriate rating for this scale. </b></p>
                <table>
                    <tr>
                        <td className='w-250'>1- No Problem</td>
                        <td className='w-250'>4- Slight to Moderate Problem</td>
                        <td className='w-250'>7- Severe Problem</td>
                    </tr>
                    <tr>
                        <td className='w-250'>2- Less than Slight Problem</td>
                        <td className='w-250'>5- Moderate Problem</td>
                        <td className='w-250'>8- Severe/Extreme Problem</td>
                    </tr>
                    <tr>
                        <td className='w-250'>3- Slight Problem</td>
                        <td className='w-250'>6- Moderate/Severe Problem</td>
                        <td className='w-250'>9- Extreme Problem</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>11. *DEPRESSION SCALE:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>12. *ANXIETY SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>13. *HYPER AFFECT SCALE: :</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDepressionScale' name='txtDepressionScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAnxietyScale' name='txtAnxietyScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtHyperAffectScale' name='txtHyperAffectScale' className='add-only' required />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>14. *THOUGHT PROCESS SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>15. *WORK/SCHOOL SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>16. *MEDICAL/PHYSICAL SCALE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtProcessScale' name='txtProcessScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSchoolScale' name='txtSchoolScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicalScale' name='txtPhysicalScale' className='add-only' required />
                        </td>
                    </tr>



                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>17. *TRAUMATIC STRESS SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>18. *SUBSTANCE USE SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>19. *DANGER TO SELF SCALE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDangerSelfScale' name='txtDangerSelfScale' className='add-only' required />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtStressScale' name='txtStressScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtUseScale' name='txtUseScale' className='add-only' required />
                        </td>

                    </tr>



                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>20. *DANGER TO OTHERS SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>21.  *FAMILY ENVIRONMENT SCALE: </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>22. *SOCIAL-LEGAL SCALE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDangerOtherScale' name='txtDangerOtherScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtEnvironmentScale' name='txtEnvironmentScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLegalScale' name='txtLegalScale' className='add-only' required />
                        </td>
                    </tr>



                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>23. *COGNITIVE PERFORMANCE SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>24. *ACTIVITIES OF DAILY LIVING (ADL) SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>25. *ABILITY TO CARE FOR SELF SCALE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPerformanceScale' name='txtPerformanceScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDailyLivingScale' name='txtDailyLivingScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSelfScale' name='txtSelfScale' className='add-only' required />
                        </td>
                    </tr>



                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>26. *INTERPERSONAL RELATIONSHIP SCALE:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>27. *FAMILY RELATIONSHIPS SCALE::</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>28. *SECURITY MANAGEMENT NEEDS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtRelationshipScale' name='txtRelationshipScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFamilyRelationshipScale' name='txtFamilyRelationshipScale' className='add-only' required />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtManagementNeeds' name='txtManagementNeeds' className='add-only' required />
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>29. County of Service:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCountyService' name='txtCountyService' className='add-only' />
                        </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}

